import "../../custom.css";
import EditTenantModal from '../../components/Modals/EditTenantModal';
import { errorToast, successToast } from '../../constants/toast';
import { useUpdateTenantMutation } from "../../utilities/mutations/useUpdateTenantMutation";

export default function EditTenantViewModel({ isOpen, toggle, accountId, makeToast }) {
    const { mutateAsync: updateAsync, error: getError } = useUpdateTenantMutation();
     
    const cancelHandler = (event) => {
        event.preventDefault(); 
        toggle();
    }

    const failedCall = () => {
        makeToast("Error editing HQ details. Error message: ", errorToast)
    }

    const editTenantSubmit = async (e) => {
        //e.preventDefault();
        if (e?.target?.tenantName?.value?.trim().length === 0) {
            makeToast("Please enter a valid HQ name", errorToast);
            return;
        }
        var response = await updateAsync({ e }, { onError: failedCall });

        makeToast("HQ Updated successfully", successToast);
        toggle();
    }

    return (
        <EditTenantModal
            isOpen={isOpen}
            cancel={cancelHandler}
            accountId={accountId}
            submitHandler={editTenantSubmit}
        />
    )

};